import { List, ListItem, ListItemText, Typography } from '@mui/material'
import * as React from 'react'
import { ICourse } from '../../../interfaces/ICourse'
import { DateRange, Event, EventAvailable } from '@mui/icons-material'
import DateFunctions from '../../../services/date_functions'
import moment from 'moment'
import ContactAdminButton from '../../Classroom/ClassroomLearnersComponents/SchoolCourseDetails/ContactAdminButtonComponent'
import { ISchool } from '../../../interfaces/school.interface'

export default function CourseDetailsFeaturesIncluded(props: {
  schoolDetailsFromCourse: ISchool
  courseDetails: ICourse
}) {
  return (
    <div>
      <List disablePadding={true} style={{ padding: '20px 0px' }} dense={true}>
        {props.courseDetails && props.courseDetails.start_date && (
          <ListItem style={{ padding: '0px' }}>
            <Typography
              variant={'body2'}
              style={{
                marginRight: '10px',
                display: 'flex',
              }}
            >
              <Event style={{ marginRight: '10px' }} fontSize={'small'} />
              Start date:
            </Typography>
            <ListItemText>
              <Typography variant={'body2'} style={{ display: 'flex' }}>
                {DateFunctions.convertDateFromDBFormat(
                  props.courseDetails.start_date,
                  true,
                )}
              </Typography>
            </ListItemText>
          </ListItem>
        )}

        {props.courseDetails && props.courseDetails.end_date && (
          <ListItem style={{ padding: '0px' }}>
            <Typography
              variant={'body2'}
              style={{
                marginRight: '10px',
                display: 'flex',
              }}
            >
              <EventAvailable
                style={{ marginRight: '10px' }}
                fontSize={'small'}
              />
              End date:{' '}
            </Typography>
            <ListItemText>
              <Typography variant={'body2'}>
                {DateFunctions.convertDateFromDBFormat(
                  props.courseDetails.end_date,
                  true,
                )}
              </Typography>
            </ListItemText>
          </ListItem>
        )}

        {props.courseDetails &&
          props.courseDetails.start_date &&
          props.courseDetails.end_date && (
            <ListItem style={{ padding: '0px' }}>
              <Typography
                variant={'body2'}
                style={{
                  marginRight: '10px',
                  display: 'flex',
                }}
              >
                <DateRange style={{ marginRight: '10px' }} fontSize={'small'} />
                Duration:{' '}
              </Typography>
              <ListItemText>
                <Typography variant={'body2'}>
                  {moment(props.courseDetails.end_date).from(
                    props.courseDetails.start_date,
                    true,
                  )}
                </Typography>
              </ListItemText>
            </ListItem>
          )}

        <div>
          <ContactAdminButton school={props.schoolDetailsFromCourse} />
        </div>
      </List>
      {/*<Typography gutterBottom={true}>*/}
      {/*  <b>This course includes:</b>*/}
      {/*</Typography>*/}
      {/*<Typography*/}
      {/*  gutterBottom={true}*/}
      {/*  style={{ display: "flex" }}*/}
      {/*  variant={"body2"}*/}
      {/*>*/}
      {/*  <VideoCallIcon fontSize={"small"} style={{ marginRight: "10px" }} />*/}
      {/*  Scheduled live class*/}
      {/*</Typography>*/}
      {/*<Typography*/}
      {/*  gutterBottom={true}*/}
      {/*  style={{ display: "flex" }}*/}
      {/*  variant={"body2"}*/}
      {/*>*/}
      {/*  <LiveTvIcon fontSize={"small"} style={{ marginRight: "10px" }} />*/}
      {/*  High video quality*/}
      {/*</Typography>*/}
      {/*<Typography*/}
      {/*  gutterBottom={true}*/}
      {/*  style={{ display: "flex" }}*/}
      {/*  variant={"body2"}*/}
      {/*>*/}
      {/*  <AssessmentIcon fontSize={"small"} style={{ marginRight: "10px" }} />*/}
      {/*  Resources and Assessments*/}
      {/*</Typography>*/}
      {/*<Typography*/}
      {/*  gutterBottom={true}*/}
      {/*  style={{ display: "flex" }}*/}
      {/*  variant={"body2"}*/}
      {/*>*/}
      {/*  <ContactSupport fontSize={"small"} style={{ marginRight: "10px" }} />*/}
      {/*  Support from tutors*/}
      {/*</Typography>*/}
    </div>
  )
}
